'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

exports.initMainCarousel = initMainCarousel;

exports.default = function () {
    var $carouselActiveTab = (0, _jquery2.default)('.tab-pane.active [data-carousel]', this);
    var $carouselNoTabs = (0, _jquery2.default)('[data-carousel]').not('.tab-pane [data-carousel]', this);

    // select visible carousels
    var $carousels = $carouselNoTabs.add($carouselActiveTab);

    initMainCarousel($carousels);

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = (0, _getIterator3.default)(document.querySelectorAll('.talk-about__aside')), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var talkAboutItem = _step.value;

            registerCarouselItemTouch(talkAboutItem);
        }

        // HP teaser
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    var $hpTeaserCarousel = (0, _jquery2.default)('#hpTeaser', document);
    if ($hpTeaserCarousel.length && !$hpTeaserCarousel.hasClass('slick-initialized')) {

        var setBackgroundImage = function setBackgroundImage($elm) {
            $elm.each(function () {
                var $this = (0, _jquery2.default)(this);
                if ((0, _linksoftAlbatros.isMaxWidth)('sm') && $this.hasClass('h-t__bg--mobile')) {
                    $this = $this.not('.h-t__bg--desktop');
                } else {
                    $this = $this.not('.h-t__bg--mobile');
                }

                $this.css('background-image', 'url(' + $this.data('bg') + ')');
            });
        };

        $hpTeaserCarousel.on('beforeChange', function (e, slick, currentSlide, nextSlide) {
            var $nextSlide = (0, _jquery2.default)('a', slick.$slides.eq(nextSlide));

            // prevent click by dots
            if ($nextSlide.attr('src') === undefined) {
                setBackgroundImage($nextSlide);
            }

            // set bg for next invisble one for smooth switching
            setBackgroundImage((0, _jquery2.default)('a', slick.$slides.eq(nextSlide + 1)));
        });

        // first init
        $hpTeaserCarousel.on('init', function (e, slick) {

            // make first image load first!
            setBackgroundImage((0, _jquery2.default)('a', slick.$slides.eq(0)));

            // prevent image blink
            if (slick.$slides.length > 1) {
                (0, _jquery2.default)('.slick-cloned', $hpTeaserCarousel).each(function () {
                    setBackgroundImage((0, _jquery2.default)('a', this));
                });

                for (var i = 0; i < 2; ++i) {
                    setBackgroundImage((0, _jquery2.default)('a', slick.$slides.eq(i)));
                }
            } else {
                // init background when there are just 1 item
                setBackgroundImage((0, _jquery2.default)('a', this));
            }
        });

        $hpTeaserCarousel.slick({
            dots: true,
            prevArrow: prevArrow,
            nextArrow: nextArrow,
            autoplay: true,
            autoplaySpeed: 7000,
            appendArrows: $hpTeaserCarousel.parent().next()
        });
    }

    // HP talk about
    var $hpTalkAboutCarousel = (0, _jquery2.default)('#hpTalkAbout', document);
    if ($hpTalkAboutCarousel.length && !$hpTalkAboutCarousel.hasClass('slick-initialized')) {
        var currentSlickBefore = 0;

        $hpTalkAboutCarousel.slick({
            adaptiveHeight: true,
            dots: true,
            prevArrow: prevArrow,
            nextArrow: nextArrow,
            appendArrows: $hpTalkAboutCarousel.closest('section').find('.h-t__arrows'),
            appendDots: (0, _jquery2.default)('.talk-about__wrap')
        });

        $hpTalkAboutCarousel.on('beforeChange', function (e, s, currentSlide) {
            currentSlickBefore = currentSlide;
        });

        // hide long text
        $hpTalkAboutCarousel.on('afterChange', function (e, s, currentSlide) {

            if (currentSlickBefore !== currentSlide) {
                (0, _jquery2.default)('.text-short', $hpTalkAboutCarousel).removeClass('hidden');
                (0, _jquery2.default)('.text-long', $hpTalkAboutCarousel).addClass('hidden');
                (0, _jquery2.default)('.show-more-text', $hpTalkAboutCarousel).show();
            }
        });
    }

    // HP categories
    var $hpCategories = (0, _jquery2.default)('#hpCategories', document);
    if ($hpCategories.length && !$hpCategories.hasClass('slick-initialized')) {

        $hpCategories.slick({
            slidesToShow: 5,
            slidesToScroll: 5,
            prevArrow: prevArrow,
            nextArrow: nextArrow,
            appendArrows: $hpCategories.next(),
            responsive: [{
                breakpoint: 930,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4,
                    accessibility: false
                }
            }, {
                breakpoint: 767,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    accessibility: false
                }
            }, {
                breakpoint: 575,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    accessibility: false
                }
            }]
        });
    }

    var $carouselSmall = (0, _jquery2.default)('.carousel--sm', document);

    if ($carouselSmall.length && !$carouselSmall.hasClass('slick-initialized')) {

        $carouselSmall.slick({
            dots: true,
            slidesToShow: 6,
            slidesToScroll: 6,
            infinity: false,
            // centerMode: true,
            prevArrow: prevArrow,
            nextArrow: nextArrow,
            appendArrows: $carouselSmall.next(),
            responsive: [{
                breakpoint: 1470,
                settings: {
                    variableWidth: true,
                    slidesToShow: 5,
                    slidesToScroll: 5,
                    accessibility: false
                }
            }, {
                breakpoint: 1366,
                settings: {
                    variableWidth: true,
                    slidesToShow: 4,
                    slidesToScroll: 4,
                    accessibility: false
                }
            }, {
                breakpoint: 767,
                settings: {
                    variableWidth: true,
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    accessibility: false
                }
            }, {
                breakpoint: 575,
                settings: {
                    arrows: false,
                    centerMode: true,
                    dots: false,
                    variableWidth: true,
                    slidesToShow: 1,
                    accessibility: false
                }
            }]
        });
    }

    var $seriesCarousel = (0, _jquery2.default)(".series__carousel", this);
    if ($seriesCarousel.length && !$seriesCarousel.hasClass("slick-initialized")) {
        var seriesInitClasses = function seriesInitClasses(elm) {
            (0, _jquery2.default)(elm).prev().addClass("series__item--prev");
            (0, _jquery2.default)(elm).addClass("series__item--current");
            (0, _jquery2.default)(elm).next().addClass("series__item--next");
        };

        $seriesCarousel.each(function () {
            var carousel = (0, _jquery2.default)(this);
            var itemLength = (0, _jquery2.default)(".series__item", carousel).length;
            var fistItemIndex = itemLength == 3 ? 2 : 1;

            //add fake items for rolling
            if (itemLength < 4) {
                carousel.append('<span class="series__item" />');
                carousel.prepend('<span class="series__item" />');
            }

            // init event must be before slick
            carousel.on("init", function (e, slick) {
                seriesInitClasses((0, _jquery2.default)(slick.$slides).get(fistItemIndex));
            });

            carousel.slick({
                initialSlide: fistItemIndex,
                infinite: false,
                draggable: false,
                adaptiveHeight: true,
                nextArrow: nextArrow,
                prevArrow: prevArrow,
                dots: false,
                centerMode: true,
                variableWidth: true,
                slidesToShow: 3,
                slidesToScroll: 1
            });

            // single item in series
            if (itemLength == 1) {
                (0, _jquery2.default)("a.series__item", carousel).removeClass("series__item--prev").addClass("series__item--current");
            }

            carousel.on("beforeChange", function (event, slick, currentSlide, nextSlide) {
                // prevent fast clicks
                (0, _jquery2.default)(".series__item", slick.$slider).removeClass("series__item--hide");

                // move to right
                if (currentSlide < nextSlide) {
                    (0, _jquery2.default)(".series__item--prev", slick.$slider).addClass("series__item--hide");
                } else {
                    // move to left
                    (0, _jquery2.default)(".series__item--next", slick.$slider).addClass("series__item--hide");
                }

                (0, _jquery2.default)(slick.$slides).removeClass("series__item--prev series__item--next series__item--current");
                seriesInitClasses(slick.$slides.get(nextSlide));

                if (itemLength < 4) {
                    // hide arrow before last item
                    if (nextSlide == itemLength) {
                        (0, _jquery2.default)(".arrow--right", carousel).hide();
                    } else {
                        (0, _jquery2.default)(".arrow--right", carousel).show();
                    }

                    // hide arrow for first item
                    if (nextSlide == 1) {
                        (0, _jquery2.default)(".arrow--left", carousel).hide();
                    } else {
                        (0, _jquery2.default)(".arrow--left", carousel).show();
                    }
                }
            });
        });
    }
};

exports.registerCarouselItemTouch = registerCarouselItemTouch;

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _linksoftAlbatros = require('linksoft-albatros');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import './../utils/jquery-throttle-debounce';

var prevArrow = '<button class="arrow arrow--left">\n                    <svg width="100%" height="100%" viewBox="0 0 19 54">\n                        <path class="arrow-path" d="M17.707,0.707l-17,26l17,26"/>\n                    </svg>\n                    </button>';

var nextArrow = '<button class="arrow arrow--right">\n                   <svg width="100%" height="100%" viewBox="0 0 19 54">\n                       <path class="arrow-path" d="M0.707,52.707l17,-26l-17,-26"/>\n                   </svg></button>';

var carouselOpt = {
    dots: true,
    infinite: false,
    variableWidth: true,
    prevArrow: prevArrow,
    nextArrow: nextArrow,
    responsive: [{
        breakpoint: 575,
        settings: {
            dots: false,
            centerMode: true,
            accessibility: false
        }
    }]
};

function getVisibleItemsInRow($carousel) {
    return Math.floor($carousel.width() / (0, _jquery2.default)('.carousel__item', $carousel).outerWidth());
}

function isThereHiddenItems($carousel) {
    return (0, _jquery2.default)('.carousel__item', $carousel).length > getVisibleItemsInRow($carousel);
}

function slickOptSlideToShow($carousel) {
    var items = isThereHiddenItems($carousel) ? getVisibleItemsInRow($carousel) : (0, _jquery2.default)('.carousel__item', $carousel).length;

    return {
        appendArrows: $carousel.next(),
        slidesToShow: items,
        slidesToScroll: items
    };
}

// set carousel with for nice result
function setWidthForCarousel($carousel, itemsLength) {
    if ((0, _linksoftAlbatros.isMaxWidth)('xs')) return;

    var $carouselItems = (0, _jquery2.default)('.carousel__item', $carousel);
    var carouselItemWidth = $carouselItems.outerWidth();

    if (!isThereHiddenItems($carousel)) {
        $carousel.css('width', $carouselItems.length * carouselItemWidth);
    } else {
        $carousel.css('width', itemsLength * carouselItemWidth);
    }
}

function initMainCarousel($carousels) {
    $carousels.each(function () {
        var $this = (0, _jquery2.default)(this);

        // for inline display of carousels, do not display dots
        if (this.closest('.custom-sections-inline-content')) carouselOpt.dots = false;

        var itemsOriginalLength = getVisibleItemsInRow($this);
        var optDefault = (0, _assign2.default)(slickOptSlideToShow($this), carouselOpt);

        if (!$this.hasClass('slick-initialized')) {
            $this.slick(optDefault);
            setWidthForCarousel($this, itemsOriginalLength);
            registerCarouselItemTouch($this.get().pop());
        }
    });
}

;

function registerCarouselItemTouch(carouselObject) {
    try {
        var carouselItems = carouselObject.querySelectorAll('.carousel__item');

        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
            var _loop = function _loop() {
                var item = _step2.value;

                item.addEventListener('click', function (event) {
                    return touchAction(event, item);
                });
            };

            for (var _iterator2 = (0, _getIterator3.default)(carouselItems), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                _loop();
            }
        } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                    _iterator2.return();
                }
            } finally {
                if (_didIteratorError2) {
                    throw _iteratorError2;
                }
            }
        }
    } catch (e) {
        console.error('Error in registering carousel item touch. Method: registerCarouselItemTouch.', e);
    }

    function touchAction(event, carouselItemElement) {
        try {
            if (event.target.classList.contains('redirect-stop') || event.target.closest('.redirect-stop')) {
                return;
            }
            var id = carouselItemElement.dataset.id;
            if (!id) {
                throw new Error('Missing parameter id. Value: ' + id);
            }
            window.location.href = '/Product/Detail/' + id;
        } catch (e) {
            console.error('Error in touchAction function.', e);
        }
    }
}


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/initializers/carousels.js
// module id = 575
// module chunks = 0